import { withNamespaces } from "react-i18next";
import { Text, View } from "@react-pdf/renderer";
import styles from "../../Styles";

const CompanyIdentification = ({
    t,
    company
}) => {

    const companyIdentification = [
        {
          title: "Primary Name",
          details: company?.primaryName ?? "-",
        },
        {
          title: "DUNS Number",
          details: company?.duns ?? "-",
        },
        {
          title: "Business Number",
          details: company?.businessNumber ?? "-",
        },
        {
          title: "Location Status",
          details: company?.locationStatus ?? "-",
        },
        {
          title: "Is Subsidiary Location",
          details:
            company?.isSubsidiaryLocation === true
              ? "Yes"
              : company?.isSubsidiaryLocation === false
              ? "No"
              : "-",
        },
      ];

    return (
        <View style={styles.section}>
            <Text style={styles.sectionSeparator}>
            {`${t('2.')} ${t('Company Identification & Status')}`}
            </Text>
            
            <View style={styles.table} break>
                <View style={styles.tableRow}>
                    <View style={styles.tableColHeader}>
                        <Text style={{
                            ...styles.tableCell,
                            ...styles.fontBold
                        }}>{t('Title ')}</Text>
                    </View>
                    <View style={{
                        ...styles.tableColHeader,
                        ...styles.borderRightNone
                    }}>
                        <Text style={{
                            ...styles.tableCell,
                            ...styles.fontBold
                        }}>{t('Details')}</Text>
                    </View>
                </View>

                {companyIdentification.map((d, i) => {
                    const rowStyle = {
                        ...styles.tableRow,
                        ...(i === companyIdentification.length - 1 ? styles.tableLastRow : {})
                    };

                    return (
                        <View style={rowStyle} key={i}>
                        {/* Title column */}
                        <View style={styles.tableCol}>
                            <Text style={styles.tableCell}>
                            {t(d.title)}
                            </Text>
                        </View>

                        {/* Details column */}
                        <View style={{ ...styles.tableCol, ...styles.borderRightNone }}>
                            <Text style={styles.tableCell}>
                            {d.details ?? "-"}
                            </Text>
                        </View>
                        </View>
                    );
                    })}

            </View>
        </View>
    )
};

export default withNamespaces()(CompanyIdentification);

